<template>
  <div class="contain">
    <div class="box">
      <el-form :inline="true" size="small" ref="form" :model="form" class="form">
        <el-form-item>
          <el-input v-model="form.iccid" placeholder="请输入卡号"></el-input>
        </el-form-item>
        <el-form-item class="item">
          <el-input v-model="form.version" placeholder="请输入池子编号"></el-input>
        </el-form-item>
        <el-form-item style="margin-left: 10px;">
          <el-select clearable v-model="form.status" placeholder="请选择状态">
            <el-option label="停机" :value="2"></el-option>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="待激活" :value="0"></el-option>
            <el-option label="拆机" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="item">
          <el-select clearable @focus="loadAgent" v-model="form.agentId" placeholder="代理商ID">
            <el-option  label="请选择" value="-1"></el-option>
            <el-option v-for="item in agentList" :label="item.agentName" :value="item.agentId" :key="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
            <el-button type="primary" plian size="small" icon="el-icon-search" @click="list(1)" style="margin-left:10px">搜索</el-button>
            <el-button @click="download" size="small" type="primary" plain icon="el-icon-download" style="margin-left:10px">导出</el-button>
        </el-form-item>
      </el-form>

    </div>

    <el-table ref="multipleTable" :data="tableData" :row-style="{height:'40px',textAlign:'center'}"
              :cell-style="{height:'5px,0',textAlign:'center'}"
              :header-cell-style="{background:'#f8f8f9',color:'#333',textAlign:'center'}"
              border style="width: 100%;margin-top: 1%;margin-bottom: 50px;height: 70vh">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column prop="iccid" label="ICCID" width="180">
      </el-table-column>
      <el-table-column prop="cardNo" label="接入号码" width="180">
      </el-table-column>

      <el-table-column prop="cardType" label="类型" width="150">
      </el-table-column>
      <el-table-column  prop="version" label="卡池编号" width="150">
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="name" label="卡池名称" width="180">
        <template slot-scope="{row}">
          <span v-if="agentIdPre==='zy0000'">{{row.name}}</span>
          <span v-else>{{row.nameCust}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="wrongSpecification" label="页面池子规格(单位G)" width="180" v-if="roleId==='777'">
      </el-table-column>
      <el-table-column prop="so" label="卡池so系数" width="120" v-if="roleId==='777'">
      </el-table-column>
      <el-table-column prop="agentId" label="代理商ID" width="120" v-if="roleId==='777'">
      </el-table-column>


      <el-table-column prop="status" label="卡状态" width="120" >
        <template slot-scope="scope">
          <div v-if="scope.row.status===0">待激活</div>
          <div v-if="scope.row.status===1">正常</div>
          <div v-if="scope.row.status===2">停机</div>
          <div v-if="scope.row.status===3">拆机</div>
        </template>
      </el-table-column>

      <el-table-column  prop="used" label="使用量(单位MB)" width="180">
      </el-table-column>

      <el-table-column  prop="createTime" label="创建时间" width="180" v-if="roleId==='777'">
      </el-table-column>
      <el-table-column  prop="updateTime" label="更新时间" width="180" v-if="roleId==='777'">
      </el-table-column>

    </el-table>
    <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>

  </div>
</template>

<script>
import pagination from '../../../components/pagination.vue'
export default {
  name: 'SingleCard',
  components: {
    pagination,
  },
  mounted() {
    this.agentIdPre = this.$loginUser.agentId
  },
  data() {
    return {
      agentIdPre:'',
      agentList: [],
      dialogUploading: false,
      form: {
        status: '',
        iccid: '',
        version: '',
        agentId: '',
        current: 1,
        size: 10
      },
      tableData: [],
      dialogVisible: false,
      agentJs: require('../../../api/agent'),
      poolJs: require('../../../api/pool')
    }
  },

  methods: {
    loadAgent(){
      this.agentJs.getSearchAgent(
              {}).then(res=>{
        res.data.data.map(item=>{
          let map={
            agentId: item.agentId,
            agentName: item.agentName
          }
          this.agentList.push(map)
        })

      })
    },

    //导出
    download() {
      let _this=this
      _this.poolJs.ExportingCardDetails(_this.form).then(res=>{
        if(res.data.code==='0'){
          _this.$alert("已成功导出，请到任务管理处下载")
        }else{
          _this.$alert(res.data.msg)
        }

      })
    },


    list(page) {
      let _this = this
      _this.form.current =page
      _this.form.size= _this.$refs.pagination.size
      _this.poolJs.findPoolFlow(_this.form)
        .then(response => {
          _this.tableData = response.data.data.rows
          _this.$refs.pagination.render(page, response.data.data.total)
        })
    }
  },

}
</script>

<style lang="less" scoped>

  /* 设置滚动条宽度和高度 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  ::v-deep .el-table {
    height: 88%;
    .el-table__body-wrapper {
      height: calc(100% - 48px) !important; // 表格高度减去表头的高度
      overflow-y: auto;
    }
  }





.contain {
  position: relative;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
}
.box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .form {
    display: flex;
    margin-bottom: -10px;
    margin-top: 10px;
  }

  .item {
    margin-left: 10px;
  }

  .Hup {
    display: flex;
    flex-direction: row;
  }
}
/deep/.el-form-item__content {
  display: flex;
}
/deep/ .el-input__inner {
  height: 35px;
}
.text-center {
  position: absolute;
  bottom: 10px;
  right: 0px;
}
</style>
<style lang="less" scoped>
/deep/.el-table td,
.el-table th {
  padding: 0px;
}
</style>
<style lang="less">
.el-table td,
.el-table th {
  padding: 0px !important;
}
thead.has-gutter {
  height: 40px;
}
</style>
